var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$store.getters.hasAnyRole(["aspec-admin", "lyris"])
    ? _c("section", { staticClass: "box" }, [
        _c("h1", { staticClass: "title is-5" }, [_vm._v("Aspectos iniciales")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _vm.aspectosSerie.length === 0
            ? _c("p", { staticClass: "is-italic is-mono" }, [
                _vm._v("Esta serie no tiene aspectos iniciales"),
              ])
            : _c(
                "div",
                { staticClass: "tags" },
                _vm._l(_vm.aspectosSerie, function (aspecto) {
                  return _c(
                    "p",
                    { key: aspecto.id, staticClass: "tag is-info is-medium" },
                    [
                      _vm._v(
                        "\n        " + _vm._s(aspecto.nombre) + "\n        "
                      ),
                      _c("button", {
                        staticClass: "delete is-small",
                        on: {
                          click: function ($event) {
                            return _vm.openModalDeleteAspecto(aspecto)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Agregar aspectos iniciales"),
        ]),
        _vm._v(" "),
        _vm.$store.getters.hasAnyRole(["aspec-admin", "lyris"])
          ? _c("div", { staticClass: "field is-grouped" }, [
              _c("div", { staticClass: "control is-expanded" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.aspectoNuevo,
                          expression: "aspectoNuevo",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true },
                          expression: "{required:true}",
                        },
                      ],
                      class: {
                        "is-danger": _vm.errors.has(
                          "aspecto-nuevo",
                          "aspecto-serie"
                        ),
                      },
                      attrs: {
                        name: "aspecto-nuevo",
                        "data-vv-scope": "aspecto-serie",
                      },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.aspectoNuevo = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v("- Seleccione un aspecto -")]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.aspectosDisponibles,
                        function (aspecto, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: aspecto } },
                            [_vm._v(_vm._s(aspecto.nombre))]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    attrs: {
                      disabled:
                        _vm.errors.has("aspecto-nuevo", "aspecto-serie") ||
                        this.aspectoNuevo == null,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openModalAddAspecto()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus" }),
                    _vm._v(" Agregar\n      "),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v("Puede eliminarlos de la serie haciendo clic en "),
        _c("i", { staticClass: "fas fa-times-circle" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }